<template>
  <v-row class="selection-container">
    <v-col cols="12" class="d-flex justify-center pb-0">
      <v-card-title
        class="justify-center px-0 pt-0 pb-0"
        style="color:rgba(0, 0, 0, 0.87);"
        >{{ $t("payment.howDoYouWantToPay") }}
      </v-card-title>
    </v-col>
    <v-col cols="12"> <v-divider></v-divider> </v-col>
    <v-col
      v-if="
        settings &&
          settings.paymentMethod !== 'nomobilepayment' &&
          !hideSmartphone
      "
    >
      <v-card
        v-if="settings.paymentMethod !== 'nomobilepayment'"
        outlined
        rounded
        :disabled="disabled"
        class="card-box selection d-flex justify-center align-center flex-column text-center"
        :color="mode === 'card' ? '#d2d2d2' : null"
        @click="
          $emit('update:paymentMode', 'card');
          $emit('onSelectPayment', 'card');
        "
      >
        <!-- <font-awesome-icon
          icon="credit-card"
          :style="{ color: '#000000', fontSize: 50 }"
        /> -->
        <div class="card-img">
          <img :src="`${VUE_APP_BASE_URL}/img/svg/card.svg`" />
        </div>
        <span class="mt-3"
          >{{ $t("payment.smartphone") }} {{ hideSmartphone }}</span
        >
      </v-card>
    </v-col>
    <v-col>
      <v-card
        outlined
        rounded
        :disabled="disabled"
        class="card-box selection d-flex justify-center align-center flex-column text-center"
        :color="mode === 'datafono' ? '#d2d2d2' : null"
        @click="
          $emit('update:paymentMode', 'datafono');
          $emit('onSelectPayment', 'datafono');
        "
      >
        <!-- <font-awesome-icon
          icon="credit-card"
          :style="{ color: '#000000', fontSize: 50 }"
        /> -->
        <div class="card-img">
          <img :src="`${VUE_APP_BASE_URL}/img/svg/money-online.svg`" />
        </div>
        <span class="mt-3">{{ $t("payment.dataphone") }}</span>
      </v-card>
    </v-col>
    <v-col>
      <v-card
        outlined
        rounded
        :disabled="disabled"
        class="card-box selection d-flex justify-center align-center flex-column text-center"
        :color="mode === 'cash' ? '#d2d2d2' : null"
        @click="
          $emit('update:paymentMode', 'cash');
          $emit('onSelectPayment', 'cash');
        "
      >
        <!-- <font-awesome-icon
          icon="money-bill-alt"
          :style="{ color: '#000000', fontSize: 50 }"
        /> -->
        <div class="card-img">
          <img :src="`${VUE_APP_BASE_URL}/img/svg/money.svg`" />
        </div>
        <span class="mt-3">{{ $t("payment.payCash") }}</span>
      </v-card>
    </v-col>
    <!-- <v-col>
      <v-card
        outlined
        rounded
        :disabled="disabled"
        class="selection d-flex justify-center align-center flex-column text-center"
        height="130"
        @click="onSelectCashPayment"
      >
        <font-awesome-icon
          icon="coins"
          :style="{ color: '#000000', fontSize: 50 }"
        />
        <span class="mt-1">Solicitar pago</span>
      </v-card>
    </v-col> -->
  </v-row>
</template>

<script>
export default {
  name: "CardOrCash",
  props: ["disabled", "mode", "hideSmartphone"],
  data() {
    return {
      VUE_APP_BASE_URL: process.env.VUE_APP_BASE_URL
    };
  }
};
</script>

<style lang="scss">
.selection-container {
  .card-box {
    border: 0;
    .card-img {
      width: 130px;
      height: 180px;
      margin: auto;
      border-radius: 10px !important;
      box-shadow: 0 5px 10px 1px #000;
      @media screen and (max-width: 575px) {
        width: 110px;
        height: 160px;
      }
      @media screen and (max-width: 480px) {
        width: 80px;
        height: 95px;
      }
      @media screen and (max-width: 380px) {
        width: 70px;
        height: 85px;
      }
      @media screen and (max-width: 350px) {
        width: 65px;
        height: 80px;
      }
      @media screen and (max-width: 330px) {
        width: 55px;
        height: 70px;
      }
      img {
        width: 130px;
        margin: auto;
        margin-top: 5px;
        @media screen and (max-width: 575px) {
          width: 100px;
        }
        @media screen and (max-width: 480px) {
          width: 70px;
        }
        @media screen and (max-width: 350px) {
          width: 65px;
        }
        @media screen and (max-width: 330px) {
          width: 55px;
        }
      }
    }
    @media screen and (max-width: 480px) {
      span {
        font-size: 12px;
        text-align: center;
        line-height: normal;
      }
    }
  }
  .selection {
    cursor: pointer;
  }
}
</style>
